import barba from '@barba/core';
import Splide from '@splidejs/splide';
import Swiper from 'swiper';
// import { Navigation, Pagination } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import anime from 'animejs';

export default class {

    constructor() {
        barba.hooks.beforeOnce((data) => {
            setTimeout(() => {
                this.heroSlider();
            }, 3500); 
            this.businessAsideSlider();
            this.indexRecruitSlider();
            this.freeModeSlider();
            this.jewelry01Slider();
            this.jewelry02Slider();
        });

        barba.hooks.after((data) => {
            this.heroSlider();
            this.businessAsideSlider();
            this.indexRecruitSlider();
            this.freeModeSlider();
            this.jewelry01Slider();
            this.jewelry02Slider();
        });
    }

    // testSlider(){
    //     setTimeout(() => {
    //         new Swiper ('#test--slider',{
    //             loop: true,
    //             effect :'fade',
    //             speed:2000,
    //             allowTouchMove :false,
    //             simulateTouch:false,
    //             autoplay: {
    //                 delay: 5000
    //             }
    //         })
    //     },2000);
    // }
    heroSlider() {
        const heroSlider = document.getElementById('hero--slide');
        if(heroSlider){
            const target = '#hero--slide.splide';
            const target_options = {
                type: 'fade',
                rewind: true,
                autoplay: true,
                arrows: false,
                drag: false,
                interval: 4750,
                speed: 1500,
                pauseOnHover: false,
            }
            
            const mySplide = new Splide(target, target_options);
            mySplide.mount();
        }
    }
    businessAsideSlider() {
        const businessAsideSlider = document.querySelector('.c-business-aside__slider');
        if(businessAsideSlider){
            const target = '.c-business-aside__slider.splide';
            const target_options = {
                rewind: true,
                perPage: 4,
                perMove: 1,
                pagination: false,
                gap: '40px',
                drag: true,
                snap: false,
                //loop: true,
                fixedHeight: '400px',
                arrowPath: 'M1.8,2l16,20l-16,20l36.4-20L1.8,2z',
                breakpoints: {
                    1649: {
                        perPage: 3.5,
                    },
                    1599: {
                        perPage: 3,
                    },
                    // 1349: {
                    //     perPage: 2.5,
                    // },
                    // 1199: {
                    //     perPage: 2.5,
                    // },
                    1099: {
                        perPage: 2,
                    },
                    991: {
                        destroy: true,
                    },
                }
            }
            
            const mySplide = new Splide(target, target_options);
            mySplide.mount();
        }
    }
    indexRecruitSlider() {
        new Swiper ('.p-index__recruit--slider',{
            loop: true,
            effect: 'fade',
            autoplay: {
                delay: 4000,
            },
            speed: 2500,
            allowTouchMove: false,
        })
    }
    freeModeSlider() {
        new Swiper ('.freemode--slider',{
            slidesPerView: 1.2,
            freeMode: true,
            scrollbar: {
                el: ".freemode--slider .progress--bar",
                draggable: true,
            },
            spaceBetween: 20,
            breakpoints: {
                768: {
                    slidesPerView: 1.65,
                },
                992: {
                    slidesPerView: 1.9,
                },
                1200: {
                    slidesPerView: 2.2,
                    spaceBetween: 15,
                },
                1399: {
                    slidesPerView: 2.4,
                },
                1499: {
                    slidesPerView: 2.6,
                    spaceBetween: 20,
                },
            }
        })
    }
    jewelry01Slider() {
        const jewelry01Slider = document.querySelector('.p-jewelry__brand--slider.slider01');
        if (jewelry01Slider) {
            const target = '.p-jewelry__brand--slider.slider01 .splide';
            const target_options = {
                rewind: true,
                arrows: false,
                perMove: 1,
                pagination: true,
                autoplay: true,
                interval: 4000,
                speed:1200,
                //gap: '40px',
                drag: true,
                pauseOnHover: false
            }
    
            const mySplide = new Splide(target, target_options);
    
            const thumbnails = document.getElementsByClassName('slider01 thumbnail');
            let current = 0;
    
            for (let i = 0; i < thumbnails.length; i++) {
                initThumbnail(thumbnails[i], i, mySplide); // mySplideを引数として渡す
            }
    
            mySplide.on('mounted move', function () {
                const thumbnail = thumbnails[mySplide.index];
    
                if (thumbnail) {
                    if (current) {
                        current.classList.remove('is-active');
                    }
    
                    thumbnail.classList.add('is-active');
                    current = thumbnail;
                }
            });
    
            mySplide.mount();
        }
        function initThumbnail(thumbnail, index, mySplide) {
            thumbnail.addEventListener('click', function () {
                mySplide.go(index); // 引数として受け取ったsliderを使用する
            });
        }
    }
    jewelry02Slider() {
        const jewelry01Slider = document.querySelector('.p-jewelry__brand--slider.slider02');
        if (jewelry01Slider) {
            const target = '.p-jewelry__brand--slider.slider02 .splide';
            const target_options = {
                rewind: true,
                arrows: false,
                perMove: 1,
                pagination: true,
                autoplay: true,
                interval: 4000,
                speed:1200,
                //gap: '40px',
                drag: true,
                pauseOnHover: false
            }
    
            const mySplide = new Splide(target, target_options);
    
            const thumbnails = document.getElementsByClassName('slider02 thumbnail');
            let current = 0;
    
            for (let i = 0; i < thumbnails.length; i++) {
                initThumbnail(thumbnails[i], i, mySplide); // mySplideを引数として渡す
            }
    
            mySplide.on('mounted move', function () {
                const thumbnail = thumbnails[mySplide.index];
    
                if (thumbnail) {
                    if (current) {
                        current.classList.remove('is-active');
                    }
    
                    thumbnail.classList.add('is-active');
                    current = thumbnail;
                }
            });
    
            mySplide.mount();
        }
        function initThumbnail(thumbnail, index, mySplide) {
            thumbnail.addEventListener('click', function () {
                mySplide.go(index); // 引数として受け取ったsliderを使用する
            });
        }
    }   
}
